module.exports = __webpack_public_path__ + "img/logo_npa_integrationsinitiative.13f8dbd3.svg";